import api from "../../utils/apiUserTienda";

export const obtenerUnidadesPeso = async () => {
  const res = await api.get("/api/tienda/unidades_peso/obtener");
  const data = res.data;
  if (Array.isArray(data)) return data;
  return Array.isArray(data?.data) ? data.data : [];
};

export const crearUnidadPeso = async (payload) => {
  const res = await api.post("/api/tienda/unidades_peso/crear", payload);
  return res.data;
};

export const actualizarUnidadPeso = async (id, payload) => {
  const res = await api.put(`/api/tienda/unidades_peso/actualizar/${id}`, payload);
  return res.data;
};

export const obtenerUnidadesPesoActivas = async () => {
  const res = await api.get(`/api/tienda/unidades_peso/obtener/activas`);
  const data = res.data;
  if (Array.isArray(data)) return data;
  return Array.isArray(data?.data) ? data.data : [];
};  

